import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { setField } from '../../../../reducers/seriesReducer'

import Input from '../../../common/form/Input'
import Select from '../../../common/form/Select'
import { NOTIFICATION_OPTIONS_FIVE_DAYS, NOTIFICATION_OPTIONS_TEN_DAYS } from '../NotificationOptions.js'

import styles from './SeriesDetails.module.scss'

const DESCRIPTION_MAX_LENGTH = 400

const SeriesDetails = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const {
    errors,
    title,
    reminderDescription,
    earlyReminderDays,
    lateReminderDays,
  } = useSelector(state => state.series)

  const [notificationOne, setNotificationOne] = useState(NOTIFICATION_OPTIONS_TEN_DAYS.find(p => p.value === earlyReminderDays))
  const [notificationTwo, setNotificationTwo] = useState(NOTIFICATION_OPTIONS_FIVE_DAYS.find(p => p.value === lateReminderDays))

  const handleInputChange = e => {
    const field = e.target.name
    const value = e.target.value

    if (field === 'title' && value.length > 50) {
      return
    }

    dispatch(setField({ field, value }))
  }

  const handleSelectChange = (name, e) => {
    if (name === 'earlyReminderDays') {
      setNotificationOne(e)
    } else if (name === 'lateReminderDays') {
      setNotificationTwo(e)
    }

    dispatch(setField({ field: name, value: e.value }))
  }

  return (
    <section className={styles.seriesDetails}>
      <div className='row'>
        <div className='col-8 mx-auto mt-5'>
          <p className={styles.title}>{t('events.seriesFlow.seriesDetails.heading')}</p>
          <p>{t('events.seriesFlow.seriesDetails.fillOutInfo')}</p>
          <div className='row mb-3'>
            <div className='col-6'>
              <div className='d-flex justify-content-between align-items-start'>
                <label htmlFor='title' className={styles.label}>
                  {t('events.seriesFlow.seriesDetails.seriesTitleLabel')} <span className='required-text'>*</span>
                </label>
              </div>

              <Input
                name='title'
                type='text'
                onChange={handleInputChange}
                placeholder={t('events.seriesFlow.seriesDetails.seriesTitlePlaceholder')}
                value={title}
                error={errors.title}
              />
              <p className={styles.characterCounter}>
                {t('events.seriesFlow.seriesDetails.characterCounter', { length: title.length, max: 50 })}
              </p>
            </div>
          </div>
          <div className='row mb-3'>
            <div className='col-12'>
              <p className={styles.label}>{t('events.seriesFlow.seriesDetails.communicationSettings')}</p>
              <p>{t('events.seriesFlow.seriesDetails.communicationBlurb')}</p>
            </div>
          </div>
          <div className='row mb-4'>
            <div id='SeriesNotification1Select' className='col-12 col-md-6'>
              <label htmlFor='notification-select' className={styles.label}>
                {t('events.seriesFlow.seriesDetails.notification1')}
              </label>
              <Select
                name='notification-select'
                value={notificationOne}
                options={NOTIFICATION_OPTIONS_TEN_DAYS}
                isSearchable={false}
                onChange={(e) => handleSelectChange('earlyReminderDays', e)}
                error={errors.notificationOne}
              />
            </div>
            <div id='SeriesNotification2Select' className='col-12 col-md-6'>
              <label htmlFor='notification-select' className={styles.label}>
                {t('events.seriesFlow.seriesDetails.notification2')}
              </label>
              <Select
                name='notification-select'
                value={notificationTwo}
                options={NOTIFICATION_OPTIONS_FIVE_DAYS}
                isSearchable={false}
                onChange={(e) => handleSelectChange('lateReminderDays', e)}
                error={errors.notificationTwo}
              />
            </div>
          </div>
          <div className='row mb-4'>
            <div className='col-12'>
              <label htmlFor='description' className={styles.label}>
                {t('events.seriesFlow.seriesDetails.notificationDescription')}
              </label>

              <Input
                name='reminderDescription'
                type='textarea'
                onChange={handleInputChange}
                placeholder={t('events.seriesFlow.seriesDetails.descriptionPlaceholder')}
                value={reminderDescription}
                error={errors.reminderDescription}
                maxLength={DESCRIPTION_MAX_LENGTH}
                styles={{ inputContainer: { height: '220px' } }}
              />
              <p className={styles.characterCounter}>
                {t('events.seriesFlow.seriesDetails.characterCounter', { length: reminderDescription?.length, max: DESCRIPTION_MAX_LENGTH })}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default SeriesDetails
